import { Box, getColoursFromTheme, Stack } from 'src/viewLayer/components/DesignSystem'
import { getThemeDefaultProps } from 'src/viewLayer/styling/helpers'
import devices from 'src/viewLayer/styling/mixins/mediaQueries'
import styled from 'styled-components'

const AppComponentWithBackground = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  height: 100%;
  min-height: 100vh;
  /* mobile viewport iphone se bug fix */
  min-height: -webkit-fill-available;
`

const LoginBusinessPageContainer = styled(Box)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  min-height: 100%;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  }
`

const ForgotPasswordPageContainer = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  flex-grow: 1;
  @media only screen and ${devices.fromsmall} {
    padding-top: 2rem;
  }
`

const ForgotPasswordPageCard = styled(Stack)`
  flex-grow: 0.9;
  margin: 0 auto;
  max-width: 30rem;
  @media only screen and ${devices.fromxsmall} {
    max-width: 34rem;
  }
`

const ForgotPasswordPageFormContainer = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 21rem;
  }
`

const ResetPasswordPageContainer = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  flex-grow: 1;
  @media only screen and ${devices.fromsmall} {
    padding-top: 2rem;
  }
`

const ResetPasswordPageCard = styled(Stack)`
  flex-grow: 0.9;
  margin: 0 auto;
  max-width: 30rem;
  @media only screen and ${devices.fromxsmall} {
    max-width: 34rem;
  }
`

const ResetPasswordPageFormContainer = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 21rem;
  }
`

const ForgotPasswordPageTermsContainer = styled(Box)`
  margin: 0 auto;
  width: 100%;
  @media only screen and ${devices.fromxsmall} {
    width: 24.75rem;
  }
`

const FooterContainer = styled(Stack)`
  background-color: transparent;
`

AppComponentWithBackground.defaultProps = getThemeDefaultProps()

export {
  AppComponentWithBackground,
  FooterContainer,
  ForgotPasswordPageCard,
  ForgotPasswordPageContainer,
  ForgotPasswordPageFormContainer,
  ForgotPasswordPageTermsContainer,
  LoginBusinessPageContainer,
  ResetPasswordPageCard,
  ResetPasswordPageContainer,
  ResetPasswordPageFormContainer,
}
